
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderProductBillingItemsTaxDialog extends Serenity.EntityDialog<OrderProductBillingItemsTaxRow, any> {
        protected getFormKey() { return OrderProductBillingItemsTaxForm.formKey; }
        protected getIdProperty() { return OrderProductBillingItemsTaxRow.idProperty; }
        protected getLocalTextPrefix() { return OrderProductBillingItemsTaxRow.localTextPrefix; }
        protected getService() { return OrderProductBillingItemsTaxService.baseUrl; }
        protected getDeletePermission() { return OrderProductBillingItemsTaxRow.deletePermission; }
        protected getInsertPermission() { return OrderProductBillingItemsTaxRow.insertPermission; }
        protected getUpdatePermission() { return OrderProductBillingItemsTaxRow.updatePermission; }

        protected form = new OrderProductBillingItemsTaxForm(this.idPrefix);

    }
}